import React from "react";
import {Avatar, Chip, Typography} from "@mui/material";
import moment from "moment";
import multiavatar from "@multiavatar/multiavatar";
import SVG from "react-inlinesvg";
import clsx from "clsx";
import {roles} from "../../../../utils/dictionaries/Roles";

const getAccent = (user) => {
	if (!user?.trusted) return ["var(--atl-red)", "var(--atl-yellow)"];
	if (user?.gruppo?.toUpperCase() === "AVENGERS") return ["#FBBC05", "#F57C00"];
	if (user?.gruppo?.includes("Referente")) return ["#7E57C2", "#4285F4"];
	return ["#4285F4", "#00A8E8"];
};

const roleLabel = (role) => roles[role]?.label || role?.replaceAll("ROLE_", "") || "Ruolo";

const UtenteCard = ({classes, setUserSelected, user}) => {
	const [accent, accent2] = getAccent(user);
	const visibleRoles = user.roles?.slice(0, 3) || [];
	const hiddenRoles = Math.max((user.roles?.length || 0) - visibleRoles.length, 0);

	return (
		<button
			type="button"
			className={clsx(classes.userCard, !user.trusted && classes.userCardDeleted)}
			style={{
				"--user-accent": accent,
				"--user-accent-2": accent2,
			}}
			onClick={() => setUserSelected(user)}
		>
			<div className={classes.userAvatarWrap}>
				<Avatar className={classes.userAvatar}>
					<SVG src={multiavatar(user.alias || user.username || "Atlantis")}/>
				</Avatar>
				{user.online && <span className={classes.onlineDot}/>}
			</div>

			<div className={classes.userCardBody}>
				<div className={classes.userCardTop}>
					<Typography className={classes.userAlias}>
						{user.alias || "Alias non disponibile"}
					</Typography>
					<span className={clsx(classes.statusPill, !user.trusted && classes.statusPillDeleted)}>
						{user.trusted ? (user.online ? "Online" : "Attivo") : "Cancellato"}
					</span>
				</div>

				<Typography className={classes.userMeta}>
					{user.username || "Username non disponibile"}
				</Typography>
				<Typography className={classes.userMeta}>
					{user.gruppo || "Gruppo non indicato"} · ultimo accesso {moment(user.ultimoAccesso).isValid()
						? moment(user.ultimoAccesso).format("DD/MM HH:mm")
						: "non disponibile"}
				</Typography>

				<div className={classes.rolePreview}>
					{visibleRoles.map((role) => (
						<Chip
							key={role}
							className={classes.roleChip}
							label={roleLabel(role)}
							size="small"
							style={{"--role-color": roles[role]?.color || "var(--atl-blue)"}}
						/>
					))}
					{hiddenRoles > 0 && (
						<Chip
							className={classes.roleChip}
							label={`+${hiddenRoles}`}
							size="small"
							style={{"--role-color": "var(--atl-text-soft)"}}
						/>
					)}
				</div>
			</div>
		</button>
	);
};

export default React.memo(UtenteCard);
